import { createContext } from 'react';

export const FeatureFlagsContext = createContext({ featureFlags: [] });
FeatureFlagsContext.Provider.displayName = 'FeatureFlagsContext.Provider';
FeatureFlagsContext.displayName = 'FeatureFlagsContext';

export const withFeatureFlagsProvider = Next => ({ featureFlags, ...props }) => (
  <FeatureFlagsContext.Provider value={featureFlags}>
    <Next {...props} />
  </FeatureFlagsContext.Provider>
);

export const withFeatureFlags = Next => props => (
  <FeatureFlagsContext.Consumer>
    {featureFlags => <Next featureFlags={featureFlags} {...props} />}
  </FeatureFlagsContext.Consumer>
);
